import Header from "./packages/Header";
import Footer from "./packages/Footer";
import NavHeader from "./packages/common/NavHeader";
import NavFooter from "./packages/common/NavFooter";
import { createHeader } from "./packages/Header/entry";
import useSwitchAccount from "./packages/Header/hooks/useSwitchAccount";

export { Header, Footer, NavHeader, NavFooter, createHeader, useSwitchAccount };
